import { cn } from '@/lib/utils';
import { Input } from '@/shared/ui/input';

/**
 * Who is reviewing: name and clinic, at the top of the panel. Filled in from
 * what the lab's NuCAD sent with the link (or what this browser remembers),
 * and editable, so the dentist types them at most once. Both are needed before
 * the dentist can comment or send; an empty one is marked.
 */
interface DetailsBarProps {
  name: string;
  clinic: string;
  onName: (value: string) => void;
  onClinic: (value: string) => void;
  /** After the decision: shown, not edited. */
  readOnly: boolean;
}

export function DetailsBar({ name, clinic, onName, onClinic, readOnly }: DetailsBarProps) {
  if (readOnly) {
    return (
      <div className="border-b border-border px-4 py-2.5 text-[12.5px]">
        <span className="font-semibold">{name || 'Dentist'}</span>
        {clinic && <span className="text-muted-foreground"> · {clinic}</span>}
      </div>
    );
  }
  return (
    <div className="grid grid-cols-2 gap-2 border-b border-border px-4 py-3">
      <label className="space-y-1">
        <span className="text-[11px] font-semibold text-muted-foreground uppercase">
          Your name <span className="text-warning-600">*</span>
        </span>
        <Input
          value={name}
          onChange={(event) => {
            onName(event.target.value);
          }}
          placeholder="Dr A. Kulkarni"
          aria-label="Your name"
          aria-required
          className={cn('h-8 text-[13px]', !name.trim() && 'border-warning-500/60')}
        />
      </label>
      <label className="space-y-1">
        <span className="text-[11px] font-semibold text-muted-foreground uppercase">
          Clinic <span className="text-warning-600">*</span>
        </span>
        <Input
          value={clinic}
          onChange={(event) => {
            onClinic(event.target.value);
          }}
          placeholder="Smile Studio, Pune"
          aria-label="Clinic"
          aria-required
          className={cn('h-8 text-[13px]', !clinic.trim() && 'border-warning-500/60')}
        />
      </label>
    </div>
  );
}
